import React, { useEffect, useRef } from 'react';
import styles from './ask-modal.module.css';
import bg from '../../../../../assets/gif-wrap.png';
import { useGiftWrapContext } from '../../context/GiftWrapContext';

export function AskModal({ isOpen, onClose }) {
  const { setAskModalOpen, setGiftWrapModalOpen } = useGiftWrapContext();
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (isOpen) {
      if (typeof dialog.showModal === 'function') {
        try {
          dialog.showModal();
        } catch {
          /* ignore */
        }
      }
    } else {
      if (dialog.open) {
        try {
          dialog.close();
        } catch {
          /* ignore */
        }
      }
    }

    const handleKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  const handleClose = () => {
    setAskModalOpen(false);
  };

  const addLuxuryGiftPackaging = () => {
    setAskModalOpen(false);
    setGiftWrapModalOpen(true);
  };

  return (
    <dialog
      ref={dialogRef}
      className={styles.giftWrap__skip_modal}
      aria-hidden={!isOpen}
      role="dialog"
      aria-label="Add luxury gift packaging"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <button type="button" className={styles.close} aria-label="Close" onClick={handleClose}>
        ×
      </button>

      <div className={styles.content}>
        <h1 className={styles.title}>Add Luxury Gift Packaging</h1>
        <p className={styles.subtitle}>
          Gift boxes, bags & personalised cards available. Make your gift extra special with our premium packaging
          options.
        </p>
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className="button button--primary button--white button--full-width"
          onClick={addLuxuryGiftPackaging}
        >
          ADD LUXURY GIFT PACKAGING
        </button>

        <button type="button" className="button button--tertiary button--white" onClick={handleClose}>
          NO THANKS
        </button>
      </div>
    </dialog>
  );
}
